<template>
  <div class="DocumentTab" v-if="Lead.info">
    <div v-if="Documents.length">
      <show-document v-if="isShowDocument" :item="currentItem" :file="currentItem" />
      <table v-else class="table-basic documents-table">
        <tr>
          <th>ID</th>
          <th>Title</th>
          <th>Notes</th>
          <th>Created at</th>
        </tr>
        <tbody>
        <tr v-for="document in Documents">
          <td class="id-num"><span @click="getDocument(document)">{{ document.id }}</span></td>
          <td>{{ document.title }}</td>
          <td>{{ document.comments }}</td>
          <td>{{ document.created_at | moment('YYYY-MM-DD') }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <empty-info v-else icon="/img/emptyIcon.png" />
  </div>
</template>

<script>
import EmptyInfo from "./partials/EmptyInfo";
import ShowDocument from "./document/ShowDocument";

export default {
  name: "DocumentTab",
  data() {
    return {
      currentItem: {}
    }
  },
  components: {ShowDocument, EmptyInfo},
  computed: {
    Documents() {
      return this.$store.state.documents;
    },
  },
  mounted() {
    this.updateDocuments();
  },
  methods: {
    getDocument(item) {
      this.currentItem = item;
      this.isShowDocument = true;
    }
  }
}
</script>

<style lang="scss">
@import "assets/styles/components/variables";

.DocumentTab {
  table {
    .id-num {
      color: $magenta-1;

      span {
        cursor: pointer;
      }
    }
  }
}

.button-holder {
  .btn {
    &.active {
      border: 1px solid #ce3d7d !important;
    }
  }
}
</style>
